import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const featureContent = [
   {
    img: 'icon-33c',
    title: '웹 애플리케이션 보안',
    desc: 'OWASP Top 10 기반 취약점 점검, SQL Injection·XSS·CSRF 방어, 보안 코딩 가이드 적용으로 웹 서비스를 보호합니다.',
    dataAos:'fade-up',
    dataDelay: ''
   },
   {
    img: 'icon-34c',
    title: '서버 및 클라우드 보안',
    desc: '서버 하드닝, 방화벽 정책, VPC 네트워크 보안, IAM 권한 최소화로 클라우드 인프라 보안을 강화합니다.',
    dataAos:'fade-up',
    dataDelay: '100'
   },
   {
    img: 'icon-35c',
    title: '취약점 점검 서비스',
    desc: '정기 취약점 스캔, 침투 테스트, 보안 감사 보고서 제공으로 기업 시스템의 보안 수준을 정량적으로 평가합니다.',
    dataAos:'fade-up',
    dataDelay: '200'
   },
   {
    img: 'icon-36c',
    title: '데이터 보호',
    desc: '개인정보 암호화, 데이터 마스킹, 백업 전략, GDPR·ISMS 컴플라이언스 대응으로 기업 데이터를 안전하게 보호합니다.',
    dataAos:'fade-up',
    dataDelay: '250'
   },
   {
    img: 'icon-37c',
    title: '접근 권한 관리',
    desc: '역할 기반 접근 제어(RBAC), MFA 도입, SSO 연동, 특권 계정 관리(PAM)로 내부 보안 위협을 최소화합니다.',
    dataAos:'fade-up',
    dataDelay: '300'
   },
   {
    img: 'icon-38c',
    title: '보안 운영 체계 구축',
    desc: '보안 정책 수립, 임직원 보안 교육, 사고 대응 절차, 보안 모니터링 체계 구축으로 지속적인 보안 문화를 형성합니다.',
    dataAos:'fade-up',
    dataDelay: '350'
   },
]

const FeatureFive = () => {
    return (
        <Fragment>
            <div className="row gx-4 gx-xxl-5">
                {featureContent.map((val, i)=>(
                    <div key={i} className="col-lg-4 col-md-6" data-aos={val.dataAos} data-aos-delay={val.dataDelay}>
                        <div className="feature-style-five mb-45">
                            <div className="icon mb-30">
                                <img src={`assets/img/icon/${val.img}.svg`} alt={`${val.title} 아이콘`}/>
                            </div>
                            <h2 className="mb-20">
                                <Link className="sect-title-two" to="/services-details">{val.title}</Link>
                            </h2>
                            <p>{val.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </Fragment>
    )
}

export default FeatureFive
